export default __webpack_public_path__ + "static/media/fuel.3343373c.svg";